export const dateFormat = (
	date: number | null | undefined,
	params: Intl.DateTimeFormatOptions = { year: 'numeric', month: '2-digit', day: '2-digit' },
	locale: string = 'en-US',
): string => {
	if (date === null || date === undefined) {
		return '';
	}

	const d: Date = new Date(date);

	return d.toLocaleDateString(locale, params);
};

export const dateTimeFormat = (
	date: number | null | undefined,
	params: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit' },
	locale: string = 'en-US',
): string => {
	if (date === null || date === undefined) {
		return '';
	}

	const d: Date = new Date(date);

	return d.toLocaleTimeString(locale, params);
};

export const fullDateFormat = (
	date: number | null | undefined,
	params: Intl.DateTimeFormatOptions = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' },
	locale: string = 'en-US',
): string => {
	if (date === null || date === undefined) {
		return '';
	}

	const d: Date = new Date(date);

	return d.toLocaleString(locale, params);
};

export const getBackgroundUrl = (image: string) => {
	return `url("${image?.replace('\\', '/')}")`;
};

const transliterate = (str: string): string => {
	// tslint:disable-next-line:max-line-length
	let newString = str.toLowerCase();

	const from = 'ãàáäâẽèéëêìíïîõòóöôùúüûñç'.split('');
	const to = 'aaaaaeeeeeiiiiooooouuuunc'.split('');

	from.forEach((char, index) => {
		newString = newString.replace(new RegExp(char, 'g'), to[index]);
	});

	// eslint-disable-next-line max-len
	const tr = 'A B V G D E ZH Z I Y K L M N O P R S T U F H C CH SH SCH  Y  E YU YA a b v g d e zh z i y k l m n o p r s t u f h c ch sh sch  y  e yu ya e e'.split(' ');
	let result = '';
	for (let i = 0; i < newString.length; ++i) {
		const cc = newString.charCodeAt(i);
		result += (cc === 1025 ? 'E' : (cc >= 1040 ? tr[cc - 1040] : newString[i]));
	}
	return result;
};

export const stringToUrl: (str: string, saveHyphen?: boolean) => string = (str, saveHyphen) => {
	return transliterate(str)
		.replace(/[^0-9A-Za-z\s-]+/g, '')
		.replace(/\s/g, '-')
		.replace('\'', '')
		.replace(/-/g, saveHyphen ? '-' : '')
		.replace(/&/, '')
		.toLowerCase();
};

// eslint-disable-next-line @typescript-eslint/ban-types
export const debounce = <F extends Function>(func: F, wait: number):F => {
	let timeoutID: number;
	let time = wait;

	Number.isFinite = Number.isFinite || ((value) => {
		return typeof value === 'number' && isFinite(value);
	});

	Number.isInteger = Number.isInteger || ((value) => {
		return typeof value === 'number'
			&& Number.isFinite(value)
			&& !(value % 1);
	});

	if (!Number.isInteger(time)) {
		console.log('Called debounce without a valid number');
		time = 300;
	}

	// conversion through any necessary as it wont satisfy criteria otherwise
	return <F><any> function (this:any, ...args: Array<any>) {
		clearTimeout(timeoutID);
		// eslint-disable-next-line @typescript-eslint/no-this-alias
		const self = this;

		timeoutID = window.setTimeout(() => {
			func.apply(self, args);
		}, time);
	};
};

export const equal = (a, b) => {
	return JSON.stringify(a) === JSON.stringify(b);
};

export const replaceExceptNumber = (str: string) => str.replace(/\D/g, '');
